import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import "./index.css";
import AppRouter from "./routes/AppRouter";
import { PermissionProvider } from "./contexts/ApplicationContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import MapsProvider from "./components/common/query/MapsProvider";

const removeLoadingSpinner = () => {
  const loadingContainer = document.getElementById("loading-container");
  if (loadingContainer) {
    loadingContainer.style.display = "none";
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: 300000, //5 minutos para fazer outro refetch
      refetchIntervalInBackground: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <MapsProvider>
      <PermissionProvider>
        <AppRouter />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
      </PermissionProvider>
    </MapsProvider>
  </QueryClientProvider>
);

window.addEventListener("load", removeLoadingSpinner);
